// Import: Middleware Action & Custom Types
import { CLEAN_ASSIGMENTS_ORDERS, CLEAN_ASSIGMENTS_ORDERS_ERROR } from '_models/redux/types';

// Action function
export const cleanOrdersAssignments = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_ASSIGMENTS_ORDERS,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_ASSIGMENTS_ORDERS_ERROR,
    });
  }
};
